<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="9,12 9,9 12,9 12,8 8,8 8,12" />
	<polygon points="3,3 0,3 0,4 4,4 4,0 3,0" />
	<polygon points="0,9 3,9 3,12 4,12 4,8 0,8" />
	<polygon points="9,3 9,0 8,0 8,4 12,4 12,3" />
</svg>
</template>